import { CollectionType } from 'types';

export const ITEM_TYPE = 'COLLECTION';

export const COLLECTION_TYPE_LABEL: Record<CollectionType, string> = {
  [CollectionType.MAIN_BANNER]: '메인배너',
  [CollectionType.SINGLE_BANNER]: '띠배너',
  [CollectionType.GRID]: '2열 그리드',
  [CollectionType.CARD]: '카드',
  [CollectionType.DEFAULT]: '기본',
};
